import { getPlatform } from 'utils/platform'

export const landerCTATap = (ctaTitle) => ({
  feature: 'Spend Direct Deposit',
  event_description: 'Landing Screen CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'directDepositLandingCTA',
  screen: 'directDepositLanding',
  screen_name: 'directDepositLanding',
  cta_title: ctaTitle,
})

export const formScreenViewed = () => ({
  feature: 'Spend Direct Deposit',
  event_description: 'Form Screen Viewed',
  platform: getPlatform(),
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'directDepositForm',
  screen: 'directDepositForm',
  screen_name: 'directDepositForm',
})

export const formCTATapped = (ctaTitle, destination) => ({
  feature: 'Spend Direct Deposit',
  event_description: 'Form Screen CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'directDepositFormCTA',
  screen: 'directDepositForm',
  screen_name: 'directDepositForm',
  destination,
  cta_title: ctaTitle,
})

export const signatureScreenViewed = () => ({
  feature: 'Spend Direct Deposit',
  event_description: 'Signature Screen Viewed',
  platform: getPlatform(),
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'SdirectDepositSignature',
  screen: 'directDepositSignature',
  screen_name: 'directDepositSignature',
})

export const signatureScreenCTATapped = (ctaTitle, destination) => ({
  feature: 'Spend Direct Deposit',
  event_description: 'Signature Screen CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'directDepositSignatureCTA',
  screen: 'directDepositLanding',
  screen_name: 'directDepositLanding',
  destination,
  cta_title: ctaTitle,
})

export const previewScreenViewed = () => ({
  feature: 'Spend Direct Deposit',
  event_description: 'Preview Screen Viewed',
  platform: getPlatform(),
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'directDepositPreview',
  screen: 'directDepositPreview',
  screen_name: 'directDepositPreview',
})

export const previewScreenCTATapped = (ctaTitle) => ({
  feature: 'Spend Direct Deposit',
  event_description: 'PDF Download Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'directDepositPDFDownloadCTA',
  screen: 'directDepositPreview',
  screen_name: 'directDepositPreview',
  cta_title: ctaTitle,
})
